(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-bond-day"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================================
   HEMP HOUNDS — "a day, together"
   Scroll-synced sticky photo. One rAF-throttled measurement per frame produces ONE number —
   a continuous position `q` in [0, N-1] taken from how far the photo is through its own sticky
   travel — and everything else is derived from it:

     · the rail's progress fill   → interpolated between rail nodes, so it grows with the scroll
                                    rather than jumping moment to moment
     · the photograph            → a real cross-fade between shot i and shot i+1 weighted by the
                                    fraction of q, so the image is always mid-transition, never
                                    waiting for an easing curve to catch up with the scroll
     · the active moment + accent → the moment nearest that position

   WHY CONTINUOUS, NOT STEPPED. A CSS transition on opacity/height is the wrong tool when the
   driver is scroll: the transition runs on its own clock, so it lags a fast scroll and overshoots
   a slow one. Making both a pure function of scroll position is what makes it feel locked to the
   finger. Both CSS transitions were removed for exactly this reason.

   THE TWO THINGS THAT PREVIOUSLY BROKE
   1. The photo slid under the sticky nav. The offset is now measured from the real #header-group
      (which can carry an announcement bar and a marquee as well as the nav) instead of assumed.
   2. It unpinned before the last moment was read. Driving progress from the travel itself fixes
      this by construction: q reaches N-1 exactly as the pinned phase ends, so the last moment is
      always reached while the photo is still pinned, whatever the two heights happen to be.

   Desktop only — under 900px the CSS drops the shared photo for self-contained cards, so this
   unbinds entirely rather than animating something nobody can see.
   ========================================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-daytog]');
  if (!root) return;

  var items  = Array.prototype.slice.call(root.querySelectorAll('.daytog-item'));
  var shots  = Array.prototype.slice.call(root.querySelectorAll('.daytog-shot'));
  var fill   = root.querySelector('.daytog-fill');
  var list   = root.querySelector('.daytog-list');
  var media  = root.querySelector('.daytog-media');
  var grid   = root.querySelector('.daytog-grid');
  var stamp  = root.querySelector('.daytog-media .daytog-stamp');
  var stampT = stamp ? stamp.querySelector('[data-daytog-stamp]') : null;
  var N = items.length;
  if (!N) return;

  var DESKTOP = '(min-width: 901px)';
  var mq = window.matchMedia ? window.matchMedia(DESKTOP) : null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var lastActive = -1, ticking = false, bound = false;

  /* ---- sticky offset ------------------------------------------------------------------------
     Measured, never assumed. The header shrinks 10px once scrolled and may gain or lose an
     announcement bar, so this re-runs on resize and after load. */
  function setTop() {
    var hdr = document.querySelector('#header-group')
           || document.querySelector('.hh-header')
           || document.querySelector('.header');
    if (!hdr) return;
    var h = Math.round(hdr.getBoundingClientRect().height);
    if (h > 0) root.style.setProperty('--daytog-top', (h + 20) + 'px');
  }

  /* ---- the single measurement ----------------------------------------------------------
     Progress comes from the PHOTO'S OWN STICKY TRAVEL, not from a reading line sweeping the
     moments. A sticky element is pinned for exactly (container height − its own height), and
     `stickyTop − gridTop` is how far into that it currently is. Normalising that to 0..1 means
     all N moments are always visited across the pinned phase whatever the travel happens to be —
     which is what removes the old "every moment must be at least as tall as the photo" rule, and
     with it the ~200px of dead space each moment was carrying to satisfy it. */
  function frame() {
    ticking = false;
    if (!grid) return;

    var g = grid.getBoundingClientRect();
    var mh = media ? media.getBoundingClientRect().height : 0;
    var travel = g.height - mh;
    // the resolved sticky offset (set from the real header height by setTop)
    var stickyTop = media ? (parseFloat(window.getComputedStyle(media).top) || 0) : 0;

    var p = travel > 0 ? (stickyTop - g.top) / travel : 0;
    if (p < 0) p = 0; else if (p > 1) p = 1;

    var q = p * (N - 1);
    var lo = Math.floor(q), hi = Math.min(lo + 1, N - 1), t = q - lo, i;

    // PHOTO — a genuine cross-fade weighted by the fraction, plus a whisper of scale so the
    // incoming frame settles rather than snaps. Under reduced motion the scale is dropped.
    for (i = 0; i < N; i++) {
      var o = (i === lo) ? (1 - t) : (i === hi ? t : 0);
      if (lo === hi && i === lo) o = 1;
      var sh = shots[i];
      sh.style.opacity = o;
      sh.style.transform = reduce ? 'none' : 'scale(' + (1.045 - 0.045 * o).toFixed(4) + ')';
    }

    // RAIL — interpolate between the two nodes so the fill grows smoothly with the scroll
    if (fill && list) {
      var lt = list.getBoundingClientRect().top;
      var ra = items[lo].getBoundingClientRect(), rb = items[hi].getBoundingClientRect();
      var a = (ra.top + ra.height / 2) - lt, b = (rb.top + rb.height / 2) - lt;
      fill.style.height = Math.max(0, a + (b - a) * t) + 'px';
    }

    // ACTIVE MOMENT — nearest, so the highlighted text always matches the dominant photo
    var act = Math.round(q);
    if (act !== lastActive) {
      lastActive = act;
      for (i = 0; i < N; i++) items[i].classList.toggle('is-active', i === act);
      if (media) media.setAttribute('data-accent', items[act].getAttribute('data-accent') || 'calm');
      if (stampT) stampT.textContent = items[act].getAttribute('data-time') || '';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  function bind() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setTop();
    frame();
  }

  function unbind() {
    if (!bound) return;
    bound = false;
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    // hand every moment back to the CSS card layout, fully visible and unstyled by us
    lastActive = -1;
    items.forEach(function (el) { el.classList.remove('is-active'); });
    if (fill) fill.style.height = '0px';
    shots.forEach(function (el, n) {
      el.style.opacity = n === 0 ? 1 : 0;
      el.style.transform = '';
    });
  }

  function sync() { (mq && mq.matches ? bind : unbind)(); }

  window.addEventListener('resize', setTop, { passive: true });
  window.addEventListener('load', function () { setTop(); if (bound) frame(); });

  if (mq) {
    sync();
    // Safari < 14 has no addEventListener on MediaQueryList
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  } else {
    bind();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initBundle(scope) {
    var roots = (scope || document).querySelectorAll('.hh-bundle');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.hhBundleInit) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle]'));
      var totalEl = root.querySelector('[data-bundle-total]');
      var addBtn = root.querySelector('[data-bundle-add]');
      if (!cards.length) return;
      root.dataset.hhBundleInit = '1';

      var sym = root.getAttribute('data-currency') || '$';
      var money = function (n) { return sym + (Number(n) || 0).toFixed(2); };

      /* If the shopper picked a dog size on a product page, translate each tier's carton count into a
         real supply length here too. Everything is wrapped/guarded: this block's JS is concatenated with
         every other section's, so a throw here would take all of them down. */
      try {
        var dogChews = parseFloat(localStorage.getItem('hh_dog_chews')) || 0;
        var perCarton = parseFloat(root.getAttribute('data-chews')) || 90;
        if (dogChews > 0) {
          cards.forEach(function (c) {
            var slot = c.querySelector('[data-bundle-supply]');
            var q = parseFloat(c.getAttribute('data-qty')) || 0;
            if (!slot || !q) return;
            slot.textContent = Math.round(q * perCarton / dogChews) + '-day supply for your dog';
            slot.hidden = false;
          });
        }
      } catch (e) {}

      var active = root.querySelector('[data-bundle].is-active') || cards[0];

      function setBundle(card) {
        active = card;
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', String(on));
        });
        if (totalEl) totalEl.textContent = money(parseFloat(card.getAttribute('data-price')));
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { setBundle(card); });
      });
      if (active) setBundle(active);

      /* real add-to-cart: add each configured variant, optional bundle discount code */
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!active) return;
          var csv = (active.getAttribute('data-products') || '').trim();
          var discount = active.getAttribute('data-discount') || '';
          var ids = csv ? csv.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
          var redirect = (root.getAttribute('data-cart-redirect') === 'true');

          function go() {
            if (discount) {
              window.location.href = '/discount/' + encodeURIComponent(discount) + '?redirect=/cart';
            } else if (redirect) {
              window.location.href = '/cart';
            } else {
              document.dispatchEvent(new CustomEvent('hh:cart:added'));
            }
          }

          if (!ids.length) {
            // nothing configured (design/demo mode) — just signal
            if (discount || redirect) go();
            else document.dispatchEvent(new CustomEvent('hh:cart:added'));
            return;
          }

          if (window.fetch) {
            var busy = addBtn.getAttribute('aria-busy') === 'true';
            if (busy) return;
            addBtn.setAttribute('aria-busy', 'true');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
            }).then(function () {
              addBtn.removeAttribute('aria-busy');
              go();
            }).catch(function () {
              addBtn.removeAttribute('aria-busy');
              go();
            });
          } else {
            go();
          }
        });
      }
    });
  }

  window.HH = window.HH || {};
  window.HH.initBundle = initBundle;

  function boot() { initBundle(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-bundle')) initBundle(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFaq(scope) {
    var sections = (scope || document).querySelectorAll('.hh-faq');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.hhFaqInit) return;
      section.dataset.hhFaqInit = '1';

      var items = Array.prototype.slice.call(section.querySelectorAll('.faq-item'));
      if (!items.length) return;
      var single = section.getAttribute('data-single-open') !== 'false';

      items.forEach(function (item, i) {
        var q = item.querySelector('.faq-q');
        var a = item.querySelector('.faq-a');
        if (!q || !a) return;

        var id = (section.id || 'faq') + '-panel-' + i;
        a.id = id;
        q.setAttribute('aria-controls', id);

        var startOpen = item.classList.contains('is-open');
        q.setAttribute('aria-expanded', startOpen ? 'true' : 'false');
        if (startOpen) a.style.maxHeight = a.scrollHeight + 'px';

        q.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          // close siblings for a clean accordion feel (only in single-open mode)
          if (single) {
            items.forEach(function (o) {
              if (o !== item && o.classList.contains('is-open')) {
                o.classList.remove('is-open');
                var oa = o.querySelector('.faq-a');
                var oq = o.querySelector('.faq-q');
                if (oa) oa.style.maxHeight = null;
                if (oq) oq.setAttribute('aria-expanded', 'false');
              }
            });
          }
          item.classList.toggle('is-open', !open);
          q.setAttribute('aria-expanded', String(!open));
          a.style.maxHeight = open ? null : a.scrollHeight + 'px';
        });
      });

      // keep any open panel sized correctly across reflow (fonts/resize)
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () {
          items.forEach(function (item) {
            if (!item.classList.contains('is-open')) return;
            var a = item.querySelector('.faq-a');
            var inner = item.querySelector('.faq-a-inner');
            if (a && inner) a.style.maxHeight = inner.scrollHeight + 'px';
          });
        });
        var listEl = section.querySelector('.faq-list');
        if (listEl) ro.observe(listEl);
      }
    });
  }

  function boot() { initFaq(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-faq')) initFaq(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeader(root) {
    if (!root || root.dataset.hhHeaderInit) return;
    root.dataset.hhHeaderInit = '1';

    /* ---- sticky toggle (neutralise the theme wrapper when off) ---- */
    var grp = document.getElementById('header-group');
    if (grp) {
      if (root.dataset.sticky === 'false') grp.style.position = 'static';
      else grp.style.position = '';
    }

    /* ---- is-stuck shrink / shadow on scroll ----
       rAF-throttled + a hysteresis dead-band (on >16px, off <4px). Without these, the raw
       `scrollY > 8` toggle flips on/off for every 1-2px trackpad/inertia scroll near the top,
       and because .nav animates its height over .4s each flip, the bar visibly "dances".
       The dead-band means a value has to move well past the line before it flips back. */
    var header = root.querySelector('.header');
    if (header) {
      var stuck = false, ticking = false;
      var apply = function () {
        ticking = false;
        var y = window.scrollY || window.pageYOffset || 0;
        if (!stuck && y > 16) { stuck = true; header.classList.add('is-stuck'); }
        else if (stuck && y < 4) { stuck = false; header.classList.remove('is-stuck'); }
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(apply); } };
      apply();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---- rotating announcement ---- */
    var track = root.querySelector('.announce-track');
    if (track) {
      var slides = Array.prototype.slice.call(track.querySelectorAll('.announce-slide'));
      var syncA11y = function (idx) { slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); }); };
      syncA11y(0);
      var speed = parseInt(root.dataset.rotate, 10) || 3800;
      if (slides.length > 1 && !reduce) {
        var ai = 0;
        setInterval(function () {
          slides[ai].classList.remove('is-active');
          ai = (ai + 1) % slides.length;
          slides[ai].classList.add('is-active');
          syncA11y(ai);
        }, speed);
      }
    }

    /* ---- mobile drawer ---- */
    var drawer = root.querySelector('.hh-mnav');
    var overlay = root.querySelector('[data-hh-mnav-overlay]');
    var burger = root.querySelector('.burger');
    if (drawer && overlay && burger) {
      var lastFocus = null;
      var openNav = function () {
        lastFocus = document.activeElement;
        overlay.hidden = false;
        // force reflow so the overlay transition runs
        void overlay.offsetWidth;
        drawer.classList.add('is-open');
        overlay.classList.add('show');
        burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var closeBtn = drawer.querySelector('[data-hh-mnav-close]');
        setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 120);
      };
      var closeNav = function () {
        drawer.classList.remove('is-open');
        overlay.classList.remove('show');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () { overlay.hidden = true; }, 420);
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
      };
      burger.addEventListener('click', openNav);
      overlay.addEventListener('click', closeNav);
      var cb = drawer.querySelector('[data-hh-mnav-close]');
      if (cb) cb.addEventListener('click', closeNav);
      Array.prototype.forEach.call(drawer.querySelectorAll('a'), function (a) { a.addEventListener('click', closeNav); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeNav(); });
      // simple focus trap
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = Array.prototype.slice.call(drawer.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.hh-header'), initHeader);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.hh-header') : null;
    if (el) { el.dataset.hhHeaderInit = ''; initHeader(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- HERO DOG — cursor-follow gaze (video scrub → canvas), ported from main.js §15 ---------- */
  function initHeroDog(scope) {
    var canvases = (scope || document).querySelectorAll('.hh-hero .hero-dog');
    Array.prototype.forEach.call(canvases, function (heroDog) {
      if (heroDog.dataset.hhDogInit) return;
      if (!heroDog.getContext) return;
      heroDog.dataset.hhDogInit = '1';

      var warn = function (msg) { if (window.console && console.warn) console.warn('[hh-hero] ' + msg); };

      var ctx = heroDog.getContext('2d', { alpha: true });
      if (!ctx) return;   // getContext can return null (GPU/context limits) — bail instead of throwing and killing the shared section-JS bundle
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      var N = 240, FT = 1 / 24;                 // frame count, seconds-per-frame (24fps clip)
      var SENS = 0.42;                          // share of viewport width for a full head-turn
      var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
      var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
      var enabled = heroDog.dataset.enable !== 'false';
      var posterURL = heroDog.dataset.poster;
      var webmURL = heroDog.dataset.webm;
      var movURL = heroDog.dataset.mov;
      var started = false;                      // true once the video takes over from the poster

      // instant poster (all devices) so the hero never flashes empty while the clip streams in.
      // Kept repaintable: if a clip turns out to be opaque (see frameKind) we fall back to this.
      var poster = new Image();
      poster.decoding = 'async';
      var posterReady = false;
      var paintPoster = function () {
        if (!posterReady) return;
        heroDog.width = poster.naturalWidth; heroDog.height = poster.naturalHeight;
        ctx.clearRect(0, 0, heroDog.width, heroDog.height);
        ctx.drawImage(poster, 0, 0, heroDog.width, heroDog.height);
      };
      poster.onload = function () { posterReady = true; if (!started) paintPoster(); };
      // A poster that never loads is the ONLY way this canvas can end up permanently empty, and it
      // fails silently otherwise. Under `shopify theme dev` asset_url points at cdn.shopify.com, so a
      // file that hasn't synced to the dev theme 404s here while the published theme serves it fine —
      // exactly the "blank in dev, works on the store" split. Say so instead of leaving a blank hole.
      poster.onerror = function () {
        warn('poster failed to load (hero will stay blank unless a clip loads): ' + posterURL);
      };
      if (posterURL) poster.src = posterURL;

      // WebKit reports VP9/WebM as playable but silently DROPS the alpha channel, so every frame
      // lands opaque and drawImage paints the clip's original studio backdrop as a hard rectangle
      // over the paw. Confirm the frame we just drew is genuinely cut out by sampling all four
      // corners — a matted clip is clear in every one, an alpha-blind decode is solid in every one.
      // Only a unanimous "solid" rejects the clip, so a stray paw in one corner can't misfire.
      // null = tainted canvas (cross-origin src) → can't tell, assume ok.
      // Returns 'cutout' (usable), 'opaque' (alpha-blind decode — refuse the clip), 'blank' (nothing
      // painted yet: at 'loadeddata' Safari reports videoWidth but drawImage is still a no-op, so the
      // canvas would go empty if we suppressed the poster on the strength of it), or null when the
      // canvas is tainted by a cross-origin src and we simply can't tell.
      var frameKind = function () {
        var w = heroDog.width, h = heroDog.height;
        if (!w || !h) return null;
        try {
          var clear = 0;
          var xs = [0, w - 1], ys = [0, h - 1];
          for (var i = 0; i < 2; i++) {
            for (var j = 0; j < 2; j++) {
              if (ctx.getImageData(xs[i], ys[j], 1, 1).data[3] < 250) clear++;
            }
          }
          if (clear === 0) return 'opaque';                             // every corner solid
          // Centre-chest is always dog on a real frame; transparent there means nothing was painted.
          if (ctx.getImageData(w >> 1, (h * 0.64) | 0, 1, 1).data[3] < 8) return 'blank';
          return 'cutout';
        } catch (e) { return null; }
      };

      var setupScrub = function (video) {
        if (video.videoWidth) { heroDog.width = video.videoWidth; heroDog.height = video.videoHeight; }
        var DUR = video.duration || N * FT;
        var lastT = Math.min((N - 1) * FT, DUR - 0.001);
        var timeFor = function (norm) { return clamp((norm + 1) / 2 * lastT, 0, lastT); };  // -1 → left, +1 → right
        var targetT = lastT / 2, curT = lastT / 2, raf = 0, active = true, seeking = false, lastSeek = -1;
        var verified = false, rejected = false;

        // CLEAR first — frames are transparent, so without this every prior frame bleeds through.
        var drawV = function () {
          if (!video.videoWidth) return false;
          ctx.clearRect(0, 0, heroDog.width, heroDog.height);
          ctx.drawImage(video, 0, 0, heroDog.width, heroDog.height);
          if (!verified) {
            var kind = frameKind();
            if (kind === 'opaque') { verified = true; rejected = true; return false; }
            // 'blank' → stay unverified and report no draw, so the poster keeps showing and we
            // re-check on the next frame instead of suppressing it for an empty canvas.
            if (kind === 'blank') { paintPoster(); return false; }
            verified = true;
          }
          return true;
        };
        // Paint the first decoded frame IMMEDIATELY. Resizing the canvas above clears it, so if we waited
        // only for 'seeked' (which can be slow or never fire when `theme dev` serves the clip cross-origin
        // from cdn.shopify.com) the canvas would sit blank with the poster already suppressed. Draw now so
        // the dog is visible the instant the clip is decodable; `started` flips only on a REAL draw, so the
        // poster stays as the fallback until a video frame actually lands.
        if (drawV()) started = true;
        if (rejected) return false;   // caller tears the clip down and restores the poster
        // `seeking` is a latch cleared by the 'seeked' event. If a single seek never reports back —
        // Safari drops them under load, on tab-switch, and while the decoder is still warming up —
        // the latch would stay set and every later pump() would bail, freezing the dog for good.
        // The watchdog releases it so a lost event costs one stutter instead of the whole scrub.
        var stuck = 0;
        var unstick = function () { if (stuck) { clearTimeout(stuck); stuck = 0; } };
        var pump = function () {
          if (seeking) return;
          var t = clamp(curT, 0, lastT);
          if (Math.abs(t - lastSeek) < FT * 0.25) return;
          seeking = true; lastSeek = t; video.currentTime = t;
          unstick();
          stuck = setTimeout(function () { stuck = 0; seeking = false; kick(); }, 350);
        };
        video.addEventListener('seeked', function () {
          unstick();
          seeking = false;
          if (drawV()) { started = true; }
          else if (rejected) { active = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } paintPoster(); return; }
          pump();
        });

        var tick = function () {
          curT += (targetT - curT) * 0.22;
          var done = Math.abs(targetT - curT) < FT * 0.4;
          if (done) curT = targetT;
          pump();
          raf = (active && !done) ? requestAnimationFrame(tick) : 0;
        };
        var kick = function () { if (!raf && active) raf = requestAnimationFrame(tick); };

        pump();

        window.addEventListener('pointermove', function (e) {
          var r = heroDog.getBoundingClientRect();
          var cx = r.left + r.width / 2;
          var norm = clamp((e.clientX - cx) / (window.innerWidth * SENS), -1, 1);
          targetT = timeFor(norm);
          kick();
        }, { passive: true });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (ents) {
            active = ents[0].isIntersecting;
            if (active) kick(); else if (raf) { cancelAnimationFrame(raf); raf = 0; }
          }, { threshold: 0 }).observe(heroDog);
        }
        document.addEventListener('visibilitychange', function () {
          active = !document.hidden;
          if (active) kick(); else if (raf) { cancelAnimationFrame(raf); raf = 0; }
        });
        return true;
      };

      // Load the clip ONLY where the scrub runs: enabled + fine-pointer + desktop width.
      if (enabled && !reduce && fine && window.innerWidth > 960 && (webmURL || movURL)) {
        var mk = function () {
          var v = document.createElement('video');
          v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto';
          v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
          v.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none';
          return v;
        };
        var teardown = function (v) {
          try { v.pause(); } catch (e) {}
          if (v.src && v.src.indexOf('blob:') === 0) URL.revokeObjectURL(v.src);
          v.removeAttribute('src');
          try { v.load(); } catch (e) {}
          if (v.parentNode) v.parentNode.removeChild(v);
        };

        // Source order. WebKit (desktop Safari + every iOS browser) plays VP9/WebM but ignores its
        // alpha channel, so the HEVC-alpha .mov has to win there; everywhere else WebM/VP9-alpha is
        // the lighter, better-supported path. frameKind() above is the backstop if this guess is wrong.
        var ua = navigator.userAgent;
        var webkit = /\b(iPad|iPhone|iPod)\b/.test(ua) ||
                     (/Safari/.test(ua) && !/Chrom(e|ium)|Edg|OPR|SamsungBrowser|Android/.test(ua));
        var queue = [];
        (webkit ? [movURL, webmURL] : [webmURL, movURL]).forEach(function (u) { if (u) queue.push(u); });

        var attempt = 0, loadNext;
        // `att` groups the (at most two) elements one source may wire up — the in-memory blob copy
        // and, if that stalls, the direct CDN copy. `force` is for a clip that decodes but has no
        // usable alpha: the source itself is a dead end, so don't wait on its sibling element.
        var wire = function (v, att) {
          att.wired++;
          var live = function () { return !started && attempt === att.id; };
          var give = function (force, why) {              // this clip is unusable → try the next source
            warn('clip dropped (' + why + '): ' + att.src);
            teardown(v);
            att.failed++;
            if (live() && (force === true || att.failed >= att.wired)) { paintPoster(); loadNext(); }
          };
          v.addEventListener('loadeddata', function () {
            if (!live()) { teardown(v); return; }
            if (setupScrub(v) === false) give(true, 'no usable alpha');   // opaque decode — refuse it
          }, { once: true });
          v.addEventListener('error', function () {
            var e = v.error;
            give(false, e ? 'media error ' + e.code : 'media error');
          }, { once: true });
          document.body.appendChild(v);
          v.load();
        };
        loadNext = function () {
          if (started || !queue.length) return;
          var src = queue.shift(), att = { id: ++attempt, src: src, wired: 0, failed: 0 }, directStarted = false;
          var live = function () { return !started && attempt === att.id; };
          var direct = function () {
            if (directStarted || !live()) return;
            directStarted = true;
            var v = mk(); v.src = src; wire(v, att);     // cross-origin → canvas taints, frameKind() opts out
          };
          if (location.protocol === 'file:') { direct(); return; }
          fetch(src).then(function (r) { return r.ok ? r.blob() : Promise.reject(r.status); }).then(function (blob) {
            if (!live()) return;
            var v = mk(); v.src = URL.createObjectURL(blob); wire(v, att);
          }).catch(function (e) {
            warn('blob fetch failed (' + e + '), retrying cross-origin: ' + src);
            direct();
          });
          setTimeout(direct, 7000);
        };
        loadNext();
      }
    });
  }

  /* ---------- HERO KIBBLE BURST (click to scatter dog food) — ported 1:1 from main.js §16 ----------
     A single shared particle system (matches the source). Click anywhere in the hero (except on a
     link/button/field) to burst food-shaped particles that fly, tumble, fall and fade. */
  var kSvg = function (s) { return 'url("data:image/svg+xml,' + encodeURIComponent(s) + '")'; };
  var KIBBLE_SHAPES = [
    kSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><circle cx='10' cy='10' r='9' fill='#7c5533'/><circle cx='7' cy='8' r='1.3' fill='#43301c'/><circle cx='12.5' cy='11' r='1.1' fill='#43301c'/><circle cx='10' cy='6.5' r='.9' fill='#43301c'/></svg>"),
    kSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><circle cx='10' cy='10' r='9' fill='#a9784b'/><circle cx='8' cy='9' r='1.2' fill='#6b4a2b'/><circle cx='12' cy='7.5' r='1' fill='#6b4a2b'/><circle cx='11.5' cy='12' r='1.1' fill='#6b4a2b'/></svg>"),
    kSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><circle cx='10' cy='10' r='9' fill='#7c5533'/><circle cx='7' cy='8' r='1.3' fill='#43301c'/><circle cx='12.5' cy='11' r='1.1' fill='#43301c'/><circle cx='10' cy='6.5' r='.9' fill='#43301c'/></svg>"),
    kSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><g fill='#f0e6d2' stroke='#d8c8a8' stroke-width='.6'><rect x='6' y='9.5' width='12' height='5' rx='2.5'/><circle cx='6' cy='9.5' r='2.9'/><circle cx='6' cy='14.5' r='2.9'/><circle cx='18' cy='9.5' r='2.9'/><circle cx='18' cy='14.5' r='2.9'/></g></svg>"),
    kSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><g fill='#b98fd6'><ellipse cx='6' cy='9' rx='2.3' ry='3'/><ellipse cx='10' cy='6' rx='2.5' ry='3.3'/><ellipse cx='14' cy='9' rx='2.3' ry='3'/><ellipse cx='10' cy='14' rx='4' ry='3.8'/></g></svg>"),
    kSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><g fill='#f5b841'><ellipse cx='6' cy='9' rx='2.3' ry='3'/><ellipse cx='10' cy='6' rx='2.5' ry='3.3'/><ellipse cx='14' cy='9' rx='2.3' ry='3'/><ellipse cx='10' cy='14' rx='4' ry='3.8'/></g></svg>")
  ];
  var kParts = [], kRaf = 0, kLast = 0, K_CAP = 150;
  function kStep(now) {
    var dt = kLast ? Math.min((now - kLast) / 16.67, 2.5) : 1; kLast = now;
    for (var i = kParts.length - 1; i >= 0; i--) {
      var p = kParts[i];
      p.vx *= 0.985; p.vy += 0.34 * dt; p.x += p.vx * dt; p.y += p.vy * dt;
      p.rot += p.vr * dt; p.life += dt;
      var fade = p.life > p.max * 0.55 ? Math.max(0, 1 - (p.life - p.max * 0.55) / (p.max * 0.45)) : 1;
      p.el.style.transform = 'translate(' + p.x + 'px,' + p.y + 'px) rotate(' + p.rot + 'deg)';
      p.el.style.opacity = fade;
      if (p.life >= p.max || p.y > window.innerHeight + 80) { p.el.remove(); kParts.splice(i, 1); }
    }
    kRaf = kParts.length ? requestAnimationFrame(kStep) : (kLast = 0);
  }
  function kBurst(x, y) {
    var n = 16 + (Math.random() * 8 | 0);
    for (var i = 0; i < n && kParts.length < K_CAP; i++) {
      var el = document.createElement('span');
      var size = 9 + Math.random() * 13;
      el.className = 'hh-kibble';
      el.style.width = el.style.height = size + 'px';
      el.style.backgroundImage = KIBBLE_SHAPES[Math.random() * KIBBLE_SHAPES.length | 0];
      document.body.appendChild(el);
      var ang = Math.random() * Math.PI * 2, spd = 4 + Math.random() * 8.5;
      kParts.push({ el: el, x: x - size / 2, y: y - size / 2,
        vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd - (5 + Math.random() * 5),
        rot: Math.random() * 360, vr: (Math.random() - 0.5) * 26, life: 0, max: 55 + Math.random() * 35 });
    }
    if (!kRaf) { kLast = 0; kRaf = requestAnimationFrame(kStep); }
  }
  function initKibble(scope) {
    var heroes = (scope || document).querySelectorAll('.hh-hero');
    Array.prototype.forEach.call(heroes, function (hero) {
      if (hero.dataset.hhKibbleInit) return;
      if (reduce || hero.dataset.hhKibble === 'false') return;   // respect reduced-motion + the section toggle
      hero.dataset.hhKibbleInit = '1';
      hero.addEventListener('pointerdown', function (e) {
        if (e.button > 0) return;                                                  // left click only
        if (e.target.closest('a, button, .btn, input, label, select, textarea, [role="button"]')) return;
        kBurst(e.clientX, e.clientY);
      });
    });
  }

  function boot() { initHeroDog(document); initKibble(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-hero')) { initHeroDog(e.target); initKibble(e.target); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-newsletter"] && !Shopify.designMode) return;
  try {
    
/* Newsletter — AJAX-upgrades the real Shopify customer form so the signup never reloads the page.
   HH.subscribe (hh-common.js) POSTs to /contact and reports back; if it isn't there, or the request
   fails outright, we hand the form straight back to the browser for a native POST so an address is
   never lost. Native validation (type=email + required) still runs first, untouched. */
(function () {
  'use strict';
  function init(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.hh-newsletter form.news-form');
    if (!forms.length) return;
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.hhNewsBound) return;
      form.dataset.hhNewsBound = '1';
      var section = form.closest('.hh-newsletter');
      var success = section ? section.querySelector('.news-success') : null;
      var error = section ? section.querySelector('.news-error') : null;
      var btn = form.querySelector('button[type="submit"]');
      var busy = false;

      function fail(msg) {
        if (!error) return;
        error.textContent = msg;
        error.removeAttribute('hidden');
      }

      form.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); return; }
        if (!window.HH || typeof window.HH.subscribe !== 'function') return;   // no helper → native POST
        e.preventDefault();
        busy = true;
        if (error) { error.setAttribute('hidden', ''); error.textContent = ''; }
        if (window.HH.btnLoading) window.HH.btnLoading(btn, true);

        window.HH.subscribe(form).then(function (res) {
          busy = false;
          if (window.HH.btnLoading) window.HH.btnLoading(btn, false);
          if (res.ok) {
            form.setAttribute('hidden', '');
            if (success) { success.removeAttribute('hidden'); success.focus && success.focus(); }
            return;
          }
          fail(res.message || 'that email didn’t go through — mind checking it?');
        }).catch(function () {
          busy = false;
          if (window.HH.btnLoading) window.HH.btnLoading(btn, false);
          try { form.submit(); } catch (err) { fail('couldn’t sign you up just now — please try again.'); }
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-page-contact"]) return;
  try {
    
(function () {
  'use strict';
  /* No custom form logic (Shopify handles POST). This guarded shim re-scans reveals + focuses
     any success/error alert on editor reload so the section behaves in the theme editor. */
  function initContact(scope) {
    var root = scope || document;
    if (!root.querySelector || !root.querySelector('.hh-page-contact')) return;
    if (window.HH && typeof window.HH.initReveal === 'function') { window.HH.initReveal(root); }
    var alert = root.querySelector('.hh-page-contact .cc-alert');
    if (alert && typeof alert.focus === 'function') {
      try { alert.focus({ preventScroll: false }); } catch (e) { alert.focus(); }
    }
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-page-contact')) {
      initContact(e.target);
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    var a = document.querySelector('.hh-page-contact .cc-alert');
    if (a && typeof a.focus === 'function') { try { a.focus({ preventScroll: true }); } catch (e) {} }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-page-how-it-works"]) return;
  try {
    
(function () {
  'use strict';
  /* No interactive behaviour — reveals are driven by hh-common.js.
     This guarded shim only re-scans reveals when the section reloads in the editor. */
  function initHow(scope) {
    var root = scope || document;
    if (!root.querySelector || !root.querySelector('.hh-page-how-it-works')) return;
    if (window.HH && typeof window.HH.initReveal === 'function') {
      window.HH.initReveal(root);
    }
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-page-how-it-works')) {
      initHow(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-page-ingredients"]) return;
  try {
    
(function () {
  'use strict';
  /* No interactive JS — hover/reveal are pure CSS + shared hh-common.js observer.
     This guarded shim only re-scans reveals when the section reloads in the editor. */
  function initIngredients(scope) {
    var root = scope || document;
    if (!root.querySelector || !root.querySelector('.hh-page-ingredients')) return;
    if (window.HH && typeof window.HH.initReveal === 'function') {
      window.HH.initReveal(root);
    }
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-page-ingredients')) {
      initIngredients(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-page-our-story"]) return;
  try {
    
(function () {
  'use strict';
  /* No behavior of its own — only re-scan reveals when re-inserted in the editor. */
  function initOurStory(scope) {
    var root = scope || document;
    if (!root.querySelector || !root.querySelector('.hh-page-our-story')) return;
    if (window.HH && typeof window.HH.initReveal === 'function') {
      window.HH.initReveal(root);
    }
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-page-our-story')) {
      initOurStory(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-product-recommended"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRecCarousel(scope) {
    var grids = (scope || document).querySelectorAll('.hh-product-recommended .prod-grid');
    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.dataset.hhRecInit) return;
      var wrap = grid.parentElement;
      var dots = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('.prod-dot')) : [];
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.prod-card'));
      if (!dots.length || !cards.length) return;
      grid.dataset.hhRecInit = '1';

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (cards[i]) cards[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      // keep the active dot in sync with the swipe position: the card whose centre is nearest the grid's
      // centre is "current". A scroll listener is deterministic here — IntersectionObserver ratios were
      // unreliable with scroll-snap + peeking neighbours (the active dot got stuck on the first slide).
      var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
      var queued = false;
      function syncDots() {
        queued = false;
        var gr = grid.getBoundingClientRect(), mid = gr.left + gr.width / 2;
        var bi = 0, best = Infinity;
        cards.forEach(function (c, i) {
          var cr = c.getBoundingClientRect();
          var d = Math.abs(cr.left + cr.width / 2 - mid);
          if (d < best) { best = d; bi = i; }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === bi); });
      }
      function queueSync() { if (!queued) { queued = true; raf(syncDots); } }
      grid.addEventListener('scroll', queueSync, { passive: true });
      window.addEventListener('resize', queueSync, { passive: true });
      syncDots();
    });
  }

  function boot() { initRecCarousel(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-product-recommended')) initRecCarousel(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function num(el, attr) { return parseFloat(el.getAttribute(attr)) || 0; }

  function initReviews(root) {
    if (!root || root.dataset.hhRevInit) return;
    var widg = root.querySelector('.jdgm-rev-widg');
    if (!widg) return;
    root.dataset.hhRevInit = '1';

    /* ---- write-a-review toggle + star input + fake submit ---- */
    var form = root.querySelector('.jdgm-form');
    var openBtn = root.querySelector('.jdgm-write-rev-link');
    if (openBtn && form) {
      openBtn.addEventListener('click', function () {
        form.hidden = false;
        form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      var cancel = form.querySelector('.jdgm-form__cancel');
      if (cancel) cancel.addEventListener('click', function () { form.hidden = true; });

      var starWrap = form.querySelector('.jdgm-form__stars');
      if (starWrap) {
        var sbtns = Array.prototype.slice.call(starWrap.querySelectorAll('button'));
        var chosen = 0;
        sbtns.forEach(function (b, i) {
          b.addEventListener('mouseenter', function () {
            sbtns.forEach(function (x, j) { x.classList.toggle('hov', j <= i); });
          });
          b.addEventListener('click', function () {
            chosen = i + 1;
            sbtns.forEach(function (x, j) { x.classList.toggle('on', j < chosen); });
          });
        });
        starWrap.addEventListener('mouseleave', function () {
          sbtns.forEach(function (b) { b.classList.remove('hov'); });
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        form.innerHTML = '<div class="jdgm-form__thanks"><svg><use href="#s-check-circle"/></svg> Thanks! Your review has been submitted for moderation.</div>';
      });
    }

    /* ---- reviews model ---- */
    var list = root.querySelector('.jdgm-rev-widg__reviews');
    if (!list) return;
    var noRes = list.querySelector('.jdgm-no-results');
    var origOrder = Array.prototype.slice.call(list.querySelectorAll('.jdgm-rev'));
    var paginateEl = root.querySelector('.jdgm-paginate');
    var countEl = root.querySelector('.jdgm-rev-widg__reviews-title');
    var totalLabel = countEl ? countEl.textContent : '';
    var perPage = parseInt(widg.getAttribute('data-per-page'), 10) || 5;
    var state = { star: 'all', photo: false, sort: '', page: 1 };

    function filtered() {
      return origOrder.filter(function (c) {
        if (state.star !== 'all' && String(num(c, 'data-score')) !== String(state.star)) return false;
        if (state.photo && num(c, 'data-photo') < 1) return false;
        return true;
      });
    }
    function sorted(arr) {
      var a = arr.slice();
      switch (state.sort) {
        case 'highest-rating': a.sort(function (x, y) { return num(y, 'data-score') - num(x, 'data-score'); }); break;
        case 'lowest-rating':  a.sort(function (x, y) { return num(x, 'data-score') - num(y, 'data-score'); }); break;
        case 'most-helpful':   a.sort(function (x, y) { return num(y, 'data-helpful') - num(x, 'data-helpful'); }); break;
        case 'most-recent':    a.sort(function (x, y) { return num(x, 'data-days') - num(y, 'data-days'); }); break;
        case 'pictures-first': a.sort(function (x, y) { return num(y, 'data-photo') - num(x, 'data-photo'); }); break;
      }
      return a;
    }
    function buildPaginate(pages) {
      if (!paginateEl) return;
      paginateEl.innerHTML = '';
      if (pages <= 1) return;
      function addBtn(html, pg, opts) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jdgm-paginate__page' + (opts && opts.current ? ' is-current' : '');
        if (opts && opts.disabled) b.disabled = true;
        b.innerHTML = html;
        b.addEventListener('click', function () {
          state.page = pg; render();
          widg.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        paginateEl.appendChild(b);
      }
      addBtn('<svg style="transform:rotate(90deg)"><use href="#s-chev"/></svg>', state.page - 1, { disabled: state.page <= 1 });
      for (var p = 1; p <= pages; p++) addBtn(String(p), p, { current: p === state.page });
      addBtn('<svg style="transform:rotate(-90deg)"><use href="#s-chev"/></svg>', state.page + 1, { disabled: state.page >= pages });
    }
    function render() {
      var f = sorted(filtered());
      f.forEach(function (c) { list.insertBefore(c, noRes); });
      var pages = Math.max(1, Math.ceil(f.length / perPage));
      if (state.page > pages) state.page = pages;
      if (state.page < 1) state.page = 1;
      var start = (state.page - 1) * perPage, end = start + perPage;
      origOrder.forEach(function (c) { c.style.display = 'none'; });
      f.forEach(function (c, i) { c.style.display = (i >= start && i < end) ? '' : 'none'; });
      if (noRes) noRes.hidden = f.length > 0;
      if (countEl) {
        countEl.textContent = (state.star === 'all' && !state.photo) ? totalLabel
          : (f.length + (f.length === 1 ? ' review' : ' reviews'));
      }
      buildPaginate(pages);
    }

    /* ---- star filter (subtabs + histogram rows + clear) ---- */
    var subtabs = Array.prototype.slice.call(root.querySelectorAll('.jdgm-subtab'));
    var histRows = Array.prototype.slice.call(root.querySelectorAll('.jdgm-histogram__row'));
    var clearBtn = root.querySelector('.jdgm-histogram__clear-filter');
    function setStar(v) {
      state.star = v; state.page = 1;
      subtabs.forEach(function (t) { t.classList.toggle('jdgm-subtab--active', t.getAttribute('data-star') === String(v)); });
      histRows.forEach(function (r) { r.classList.toggle('is-active', String(v) !== 'all' && r.getAttribute('data-rating') === String(v)); });
      if (clearBtn) clearBtn.hidden = (v === 'all');
      render();
    }
    subtabs.forEach(function (t) { t.addEventListener('click', function () { setStar(t.getAttribute('data-star')); }); });
    histRows.forEach(function (r) { r.addEventListener('click', function () { setStar(r.getAttribute('data-rating')); }); });
    if (clearBtn) clearBtn.addEventListener('click', function () { setStar('all'); });

    /* ---- photo filter ---- */
    var photoBtn = root.querySelector('.jdgm-picture-filters__button');
    if (photoBtn) photoBtn.addEventListener('click', function () {
      state.photo = !state.photo; state.page = 1;
      photoBtn.classList.toggle('is-active', state.photo);
      render();
    });

    /* ---- sort ---- */
    var sortSel = root.querySelector('.jdgm-sort-dropdown');
    if (sortSel) sortSel.addEventListener('change', function () {
      state.sort = sortSel.value; state.page = 1; render();
    });

    /* ---- helpful voting ---- */
    Array.prototype.slice.call(root.querySelectorAll('.jdgm-rev__actions')).forEach(function (act) {
      var thumbs = Array.prototype.slice.call(act.querySelectorAll('.jdgm-rev__thumb'));
      thumbs.forEach(function (tb) {
        tb.addEventListener('click', function () {
          if (act.dataset.voted) return;
          act.dataset.voted = '1';
          var cnt = tb.querySelector('.jdgm-rev__thumb-count');
          if (cnt) cnt.textContent = (parseInt(cnt.textContent, 10) || 0) + 1;
          tb.classList.add('is-voted');
          thumbs.forEach(function (o) { o.disabled = true; });
        });
      });
    });

    /* ---- photo lightbox ---- */
    var lb = root.querySelector('.jdgm-lightbox');
    var lbImg = lb ? lb.querySelector('img') : null;
    var lbClose = lb ? lb.querySelector('.jdgm-lightbox__close') : null;
    Array.prototype.slice.call(root.querySelectorAll('.jdgm-rev__pic-link')).forEach(function (pl) {
      pl.addEventListener('click', function () {
        if (!lb) return;
        var im = pl.querySelector('img');
        if (lbImg) lbImg.src = pl.getAttribute('data-full') || (im ? im.src : '');
        lb.hidden = false;
      });
    });
    function closeLb() { if (lb) lb.hidden = true; }
    if (lbClose) lbClose.addEventListener('click', closeLb);
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.hh-product-reviews')).forEach(initReviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    if (e.target.classList && e.target.classList.contains('hh-product-reviews')) { initReviews(e.target); return; }
    var r = e.target.querySelector && e.target.querySelector('.hh-product-reviews');
    if (r) initReviews(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-product-ritual"] && !Shopify.designMode) return;
  try {
    
/* Parallax on the inset only — a few pixels of counter-drift so the two frames read as separate
   objects instead of one flat picture. Desktop only (on a phone the inset sits inside the frame and
   there is nothing to drift against), rAF-throttled, and switched off under prefers-reduced-motion.
   The transform is written as a translate3d so it stays on the compositor. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rit]');
  if (!root) return;
  var inset = root.querySelector('[data-rit-inset]');
  if (!inset) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mq = window.matchMedia ? window.matchMedia('(min-width: 901px)') : null;
  var RANGE = 26;             // total px of drift across the whole pass
  var ticking = false, bound = false;

  function frame() {
    ticking = false;
    var r = root.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    if (r.bottom < 0 || r.top > vh) return;         // off screen — nothing to do
    // 0 as the section enters from below, 1 as it leaves past the top
    var p = (vh - r.top) / (vh + r.height);
    if (p < 0) p = 0; else if (p > 1) p = 1;
    inset.style.transform = 'translate3d(0,' + ((0.5 - p) * RANGE).toFixed(2) + 'px,0)';
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }
  function bind() {
    if (bound || reduce) return;
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  }
  function unbind() {
    if (!bound) return;
    bound = false;
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    inset.style.transform = '';
  }
  function sync() { (mq && mq.matches ? bind : unbind)(); }

  if (mq) {
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  } else {
    bind();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initProdCarousel(scope) {
    var grids = (scope || document).querySelectorAll('.hh-products .prod-grid');
    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.dataset.hhProdInit) return;
      var wrap = grid.parentElement;
      var dots = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('.prod-dot')) : [];
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.prod-card'));
      if (!dots.length || !cards.length) return;
      grid.dataset.hhProdInit = '1';

      // tap a dot -> snap to that card
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (cards[i]) cards[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      // active dot = most-visible card in the scroller
      if ('IntersectionObserver' in window) {
        var ratios = new Map();
        var pio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
          var bi = 0, br = -1;
          cards.forEach(function (c, i) { var r = ratios.get(c) || 0; if (r > br) { br = r; bi = i; } });
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === bi); });
        }, { root: grid, threshold: [0.2, 0.4, 0.6, 0.8, 1] });
        cards.forEach(function (c) { pio.observe(c); });
      }
    });
  }

  function boot() { initProdCarousel(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-products')) initProdCarousel(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fill(summary) {
    var bars = summary.querySelectorAll('.rev-bar span');
    Array.prototype.forEach.call(bars, function (b) { b.style.width = (b.dataset.pct || 0) + '%'; });
  }

  function initRevBars(scope) {
    var summaries = (scope || document).querySelectorAll('.hh-reviews .rev-summary');
    Array.prototype.forEach.call(summaries, function (summary) {
      if (summary.dataset.hhRevInit) return;
      summary.dataset.hhRevInit = '1';
      if (reduce || !('IntersectionObserver' in window)) { fill(summary); return; }
      var bio = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { fill(summary); obs.disconnect(); } });
      }, { threshold: 0.4 });
      bio.observe(summary);
    });
  }

  function boot() { initRevBars(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-reviews')) initRevBars(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-struggle"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  /* Struggle cards render as a CSS scroll-snap carousel on mobile (no JS needed).
     This guarded shim only exists so the section re-scans reveals on editor reload. */
  function initStruggle(scope) {
    var root = scope || document;
    var grids = root.querySelectorAll ? root.querySelectorAll('.hh-struggle .struggle-grid') : [];
    if (!grids.length) return;
    if (window.HH && typeof window.HH.initReveal === 'function') {
      window.HH.initReveal(root);
    }
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.hh-struggle')) {
      initStruggle(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
